<template>
<div class="pagination">
    <span :class="['arrow', paging.current_page == 1 ? 'disabled' : '']" @click="goToPage('prev')"><i class="fas fa-chevron-left"></i></span>
    Page <input type="number" min="1" :max="paging.total_pages" v-model="current_page" required @change="goToPage('current_page')"> of {{ paging.total_pages }}
    <span :class="['arrow', paging.current_page == paging.total_pages ? 'disabled' : '']" @click="goToPage('next')"><i class="fas fa-chevron-right"></i></span>
</div>
</template>
<script>
export default {
    name: 'pagination',
    props: ['paging'],
    data () {
        return {
            current_page: 1
        }
    },
    created() {
		this.current_page = this.paging.current_page || 1
		this.paging.first_item = this.paging.total_items > 0 ? ((this.current_page - 1) * this.paging.items_per_page) + 1 : 0
		this.paging.last_item = Math.min(this.paging.first_item + (this.paging.items_per_page - 1), this.paging.total_items)
		this.current_page = this.paging.current_page
	},
	watch: {
		paging: function() {
			this.current_page = this.paging.current_page || 1
			this.paging.first_item = this.paging.total_items > 0 ? ((this.current_page - 1) * this.paging.items_per_page) + 1 : 0
			this.paging.last_item = Math.min(this.paging.first_item + (this.paging.items_per_page - 1), this.paging.total_items)
		}
	},
	methods: {
		goToPage(direction) {
			if (direction == 'current_page') {
				if (parseInt(this.current_page) < 1) { this.current_page = 1 }
				if (parseInt(this.current_page) > this.paging.total_pages) { this.current_page = this.paging.total_pages }
			} else {
				if (direction == 'prev' && (parseInt(this.current_page) - 1) < 1) return
				if (direction == 'next' && (parseInt(this.current_page) + 1) > this.paging.total_pages) return
				let step = (direction == 'prev') ? -1 : 1
				this.current_page = parseInt(this.current_page) + step
			}
			this.$emit('updatePage', this.current_page)
		}
	}
}
</script>
